import React from "react";
import { graphql } from "gatsby";
import { PrismicRichText } from "@prismicio/react";
import { Container, Row, Col } from "react-bootstrap";

// Card-fee lines are supporting text, not headings — whatever level they're
// entered as in Prismic, render them as a styled paragraph.
const Note = ({ children }) => <p className="content-box-note">{children}</p>;
const noteComponents = {
  heading1: Note,
  heading2: Note,
  heading3: Note,
  heading4: Note,
  heading5: Note,
  heading6: Note,
};

export const TwoColumnContent = ({ slice }) => {
  if (!slice || !slice.primary) {
    return null;
  }

  return (
    <section className="two-column-content bg-c-7 py-5 py-xl-8">
      <Container>
        <Row>
          {/* Left Column */}
          <Col xs={12} md={6}>
            <div className="content-box mb-4">
              <h3 className="text-primary">
                {slice.primary?.header_left?.text || "Default Header"}
              </h3>
              <p className="content-box-price">{slice.primary?.title_left?.text || "Default Title"}</p>
              {slice.primary?.subtitle_left?.richText ? (
                <PrismicRichText field={slice.primary.subtitle_left.richText} components={noteComponents} />
              ) : (
                <p className="content-box-note">Default Subtitle</p>
              )}
            </div>
          </Col>
          {/* Right Column */}
          <Col xs={12} md={6}>
            <div className="content-box mb-4">
              <h3 className="text-primary">
                {slice.primary?.header_right?.text || "Default Header"}
              </h3>
              <p className="content-box-price">{slice.primary?.title_right?.text || "Default Title"}</p>
              {slice.primary?.subtitle_right?.richText ? (
                <PrismicRichText field={slice.primary.subtitle_right.richText} components={noteComponents} />
              ) : (
                <p className="content-box-note">Default Subtitle</p>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export const query = graphql`
  fragment PageDataBodyTwoColumnContent on PrismicPageDataBodyTwoColumnContent {
    id
    slice_type
    primary {
      header_left {
        text
        richText
      }
      title_left {
        text
        richText
      }
      subtitle_left {
        text
        richText
      }
      header_right {
        text
        richText
      }
      title_right {
        text
        richText
      }
      subtitle_right {
        text
        richText
      }
    }
  }
    fragment HomepageDataBodyTwoColumnContent on PrismicHomepageDataBodyTwoColumnContent {
    id
    slice_type
    primary {
      header_left {
        text
        richText
      }
      title_left {
        text
        richText
      }
      subtitle_left {
        text
        richText
      }
      header_right {
        text
        richText
      }
      title_right {
        text
        richText
      }
      subtitle_right {
        text
        richText
      }
    }
  }
`;
